import React from "react";
import {ApiResponse} from "@models/axios";
import {FormattedMessage} from 'react-intl';



export const enum VideoFileType {
  "NONE" = "none",
  "PRIMARY_FILE" = "primary_file",
  "TRAILER" = "trailer",
}

export const enum VideoFileStatus {
  "NONE" = "none",
  "PENDING" = "pending",
  "QUEUED" = "queued",
  "READY" = "ready",
  "ACTIVE" = "active",
  "DISABLE" = "disable",
}

export const enum VideoFileStatus {
  "NONE" = "none",
  "PENDING" = "pending",
  "QUEUED" = "queued",
  "READY" = "ready",
  "ACTIVE" = "active",
  "DISABLE" = "disable",
  "FAILED" = "failed",
  "TRANSCODING"="trans_coding",
  "TRANSCODED"="trans_coded",
  "TRANSFERRING"="transferring",
  "TRANSFER_FAILED"="transfer_failed",
  "TRANSCODING_FAILED"="transcoding_failed",
  "NORMALIZED_FAILED"="normalized_failed"
}

export const enum VideoFileFlag {
  "NONE" = "none",
  "AVAILABLE_ONLY_IN_IRAN_REGION" = "available_only_in_iran_region",
}

export const enum VideoFileWatermarkPosition {
  "NONE" = "none",
  "RIGHT_TOP_CORNER" = "right_top_corner",
  "LEANING_RIGHT_TOP_CORNER" = "leaning_right_top_corner",
}

export const enum VideoFileProfileNameString {
  "_4k" = "_4k",
  "_2k" = "_2k",
  "_1080" = "_1080",
  "_720" = "_720",
  "_560" = "_560",
  "_480" = "_480",
  "_360" = "_360",
  "_240" = "_240",
  "_144" = "_144",
}


export const enum VideoFileTitrationType {
  "NONE" = "none",
  "START" = "start",
  "END" = "end",
}

export interface VideoFileTtitration {
  type: VideoFileTitrationType,
  start_time: string,
  end_time: string
}


export interface VideoFileMp4 {
  profile:VideoFileProfileNameString,
  relative_path:string
}

export interface VideoFileHls {
  profile:VideoFileProfileNameString,
  playlist_file_name:string
}


export interface VideoFileMetaData {
  total_count:number,
  total_completed:number,
  total_success:number,
  mp4_versions:VideoFileMp4[],
  hls_versions:VideoFileHls[]
}


export interface VideoFile extends ApiResponse {
  id: string,
  short_id: string,
  title: string,
  target_file_name: string,
  type: VideoFileType,
  flags: VideoFileFlag,
  status:VideoFileStatus,
  files_info:VideoFileMetaData,
  titrations:VideoFileTtitration[],
  created_at: string;
  modified_at: string;
}


export interface VideoFilesState {
  readonly loading: boolean
  readonly allIds: String[]
  readonly byId: object
  readonly count: number
}


export const VideoFileTypeOptions = [{
  value: VideoFileType.NONE,
  label: <FormattedMessage id="app.none" defaultMessage={`None`}/>,
}, {
  value: VideoFileType.PRIMARY_FILE,
  label: <FormattedMessage id="app.primary_file" defaultMessage={`Primary File`}/>,
}, {
  value: VideoFileType.TRAILER,
  label: <FormattedMessage id="app.trailer" defaultMessage={`Trailer`}/>,
}];


export const VideoFileStatusOptions = [{
  value: VideoFileStatus.NONE,
  label: <FormattedMessage id="app.none" defaultMessage={`None`}/>,
}, {
  value: VideoFileStatus.ACTIVE,
  label: <FormattedMessage id="app.active" defaultMessage={`Active`}/>,
}, {
  value: VideoFileStatus.DISABLE,
  label: <FormattedMessage id="app.disable" defaultMessage={`Disable`}/>,
},{
  value: VideoFileStatus.PENDING,
  label: <FormattedMessage id="app.pending" defaultMessage={`Pending`}/>,
},{
  value: VideoFileStatus.QUEUED,
  label: <FormattedMessage id="app.queued" defaultMessage={`Queued`}/>,
},{
  value: VideoFileStatus.READY,
  label: <FormattedMessage id="app.ready" defaultMessage={`Ready`}/>,
},{
  value: VideoFileStatus.FAILED,
  label: <FormattedMessage id="app.failed" defaultMessage={`Failed`}/>,
},{
  value: VideoFileStatus.TRANSCODING,
  label: <FormattedMessage id="transCoding" defaultMessage={`TransCoding`}/>,
},{
  value: VideoFileStatus.TRANSCODED,
  label: <FormattedMessage id="transCoded" defaultMessage={`TransCoded`}/>,
},{
  value: VideoFileStatus.TRANSFERRING,
  label: <FormattedMessage id="transferring" defaultMessage={`Transferring`}/>,
},{
  value: VideoFileStatus.TRANSFER_FAILED,
  label: <FormattedMessage id="app.transfer_failed" defaultMessage={`Transfer Failed`}/>,
},{
  value: VideoFileStatus.TRANSCODING_FAILED,
  label: <FormattedMessage id="transcoding_failed" defaultMessage={`Transcoding Failed`}/>,
},{
  value: VideoFileStatus.NORMALIZED_FAILED,
  label: <FormattedMessage id="transcoding_failed" defaultMessage={`Normalized Failed`}/>,
}];

export const VideoFileFlagOptions = [
//   {
//   value: VideoFileFlag.NONE,
//   label: <FormattedMessage id="app.none" defaultMessage={`None`}/>,
// },
  {
  value: VideoFileFlag.AVAILABLE_ONLY_IN_IRAN_REGION,
  label: <FormattedMessage id="app.available_only_in_iran_region" defaultMessage={`Available only in iran region`}/>,
}];


export const VideoFileWatermarkPositionOptions = [{
  value: VideoFileWatermarkPosition.NONE,
  label: <FormattedMessage id="app.none" defaultMessage={`None`}/>,
}, {
  value: VideoFileWatermarkPosition.RIGHT_TOP_CORNER,
  label: <FormattedMessage id="app.right_top_corner" defaultMessage={`Right-Top corner`}/>,
},{
  value: VideoFileWatermarkPosition.LEANING_RIGHT_TOP_CORNER,
  label: <FormattedMessage id="app.leaning_right_top_corner" defaultMessage={`Leaning right-top corner`}/>,
}];


export const VideoFileTitrationTypeOptions = [{
  value: VideoFileTitrationType.START,
  label: <FormattedMessage id="app.start_titration" defaultMessage={`Start Titration`}/>,
},{
  value: VideoFileTitrationType.END,
  label: <FormattedMessage id="app.end_titration" defaultMessage={`End Titration`}/>,
}];



export const VideoFileProfileNameStringOptions = [{
  value: VideoFileProfileNameString._144,
  label: "144",
},{
  value: VideoFileProfileNameString._240,
  label: "240",
},{
  value: VideoFileProfileNameString._360,
  label: "360"
},{
  value: VideoFileProfileNameString._480,
  label: "480"
},{
  value: VideoFileProfileNameString._560,
  label: "560"
},{
  value: VideoFileProfileNameString._720,
  label: "720"
},{
  value: VideoFileProfileNameString._1080,
  label: "1080"
},{
  value: VideoFileProfileNameString._2k,
  label: "2K"
},{
  value: VideoFileProfileNameString._4k,
  label: "4k"
}];